export * from './config/dialog.translations';
export * from './config/dialog.type';
export * from './config/dialog.colors';
export * from './config/dialog.config';
export * from './config/custom-dialog-with-actions.component';
export * from './dialog.component';
export * from './services/dialog.service';
export * from './models/dialog.result';
export * from './dialog.module';
